import { __rest } from "tslib";
import clsx from 'clsx';
import { string } from 'prop-types';
import React from 'react';
import './PageBackground.less';
export default function PageBackground(props) {
    const { className } = props, otherProps = __rest(props, ["className"]);
    return React.createElement("div", Object.assign({ className: clsx('kal-page-background', className) }, otherProps));
}
PageBackground.propTypes = {
    /** Applied directly to the root DOM element */
    className: string,
};
//# sourceMappingURL=PageBackground.js.map